import { render, staticRenderFns } from "./NewsOverview.vue?vue&type=template&id=63837c18"
import script from "./NewsOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsOverview.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports